import Vue from "vue";

Vue.filter("humanJobStatus", function (value: string): string {
  if (!value) {
    return "";
  }
  return value.replace("_", " ");
});
